/* SET STATE */
export const SET_STATE_PRODUCTTYPE = "SET_STATE_PRODUCTTYPE"

/* PRODUCTTYPES */
export const GET_PRODUCTTYPES = "GET_PRODUCTTYPES"
export const GET_PRODUCTTYPES_SUCCESS = "GET_PRODUCTTYPES_SUCCESS"
export const GET_PRODUCTTYPES_FAIL = "GET_PRODUCTTYPES_FAIL"

/* PRODUCTTYPE */
export const GET_PRODUCTTYPE = "GET_PRODUCTTYPE"
export const GET_PRODUCTTYPE_SUCCESS = "GET_PRODUCTTYPE_SUCCESS"
export const GET_PRODUCTTYPE_FAIL = "GET_PRODUCTTYPE_FAIL"

/**
 * ADD PRODUCTTYPE
 */
 export const ADD_NEW_PRODUCTTYPE = "ADD_NEW_PRODUCTTYPE"
 export const ADD_PRODUCTTYPE_SUCCESS = "ADD_PRODUCTTYPE_SUCCESS"
 export const ADD_PRODUCTTYPE_FAIL = "ADD_PRODUCTTYPE_FAIL"

 /**
 * UPDATE PRODUCTTYPE
 */
export const UPDATE_PRODUCTTYPE = "UPDATE_PRODUCTTYPE"
export const UPDATE_PRODUCTTYPE_STATUS = "UPDATE_PRODUCTTYPE_STATUS"
export const UPDATE_PRODUCTTYPE_SUCCESS = "UPDATE_PRODUCTTYPE_SUCCESS"
export const UPDATE_PRODUCTTYPE_FAIL = "UPDATE_PRODUCTTYPE_FAIL"

/**
 * DELETE PRODUCTTYPE
 */
export const DELETE_PRODUCTTYPE = "DELETE_PRODUCTTYPE"
export const DELETE_PRODUCTTYPE_SUCCESS = "DELETE_PRODUCTTYPE_SUCCESS"
export const DELETE_PRODUCTTYPE_FAIL = "DELETE_PRODUCTTYPE_FAIL"
